import styles from './ErrorPage.module.scss'

function ErrorPage ({status = 404, message = 'Page not found'}) {

    return (
        <div>
            <h1 className={styles["status"]}>{status}</h1>
            <h2 className={styles["message"]}>{message}</h2>
        </div>
    )
}

export default ErrorPage;